import { type CustomHostnamePointer, getExpectedCNAME } from '@gitbook/app-database';

/**
 * Get the CNAME of a hostname pointer,
 * if pointer type is organization or its content has organization property then calls getExpectedCNAME with HostnamePointerOrganization type object.
 */
export function useCNAMERecord(pointer: CustomHostnamePointer): string {
    if (pointer.type === 'organization') {
        return getExpectedCNAME({ type: 'organization', organization: pointer.organization });
    }

    throw new Error(`Could not determine cname owner for hostname ${pointer.type}`);
}
